<div class="content-scale-wrapper">
    <div class="layout-center">
        <!-- TOPBAR -->
        <app-topbar>
            <div left class="flex items-center gap-3">
                <app-brand-logo
                    [linkTo]="['/']"
                    ariaLabel="Radiopharm — página pública"
                ></app-brand-logo>
                @if (isLogin$ | async) {
                    <app-nav-button
                        routerLink="/home"
                        icon="home"
                        aria-label="Ir al panel de la aplicación"
                    ></app-nav-button>
                }
            </div>

            <div right class="flex items-center gap-3">
                @if (isLogin$ | async) {
                    <app-plan-badge
                        mode="header"
                        [planId]="(subscription$ | async)?.plan_id"
                        routerLink="/subscriptions/account"
                    />

                    <button matButton="filled" type="button" data-testid="app-logout" (click)="logout()">
                        Logout
                    </button>
                } @else {
                  
                    <button matButton="filled" routerLink="/auth/login" data-testid="app-login">
                        Login
                    </button>
                }
            </div>
        </app-topbar>

        <mat-sidenav-container style="background: var(--mat-sys-color-surface)">
            @if (isLogin$ | async) {
                <mat-sidenav
                    #snav
                    mode="side"
                    opened
                    role="navigation"
                    style="
                        background: var(--mat-sys-color-surface);
                        border-color: var(--mat-sys-color-outline-variant);
                    "
                >
                    <mat-nav-list class="p-2 flex flex-col" aria-label="Principal">
                        <app-nav-item
                            tourAnchorId="app-nav-dose-calculator"
                            routerLink="/dose-calculator"
                            label="Dose Calculator"
                            icon="calculate"
                            testId="nav-dose-calculator"
                        ></app-nav-item>

                        <app-nav-item
                            tourAnchorId="app-nav-history"
                            routerLink="/history"
                            label="Historial"
                            icon="history"
                            testId="nav-history"
                        ></app-nav-item>

                        <app-nav-item
                            tourAnchorId="app-nav-protocols"
                            routerLink="/radiopharmaceutical"
                            label="Protocolos / EANM"
                            icon="menu_book"
                        ></app-nav-item>

                        <app-nav-item
                            tourAnchorId="app-nav-subscription"
                            routerLink="/subscriptions"
                            label="Suscripción"
                            icon="workspace_premium"
                            testId="nav-subscriptions"
                            [exact]="true"
                        ></app-nav-item>

                        <app-nav-item
                            tourAnchorId="app-nav-account"
                            routerLink="/subscriptions/account"
                            label="Mi cuenta"
                            icon="person"
                        ></app-nav-item>

                        <app-nav-item
                            tourAnchorId="app-nav-profile"
                            routerLink="/profile"
                            label="Mi perfil"
                            icon="badge"
                        ></app-nav-item>

                        @if (isAdmin()) {
                            <app-nav-item
                                tourAnchorId="app-nav-admin"
                                routerLink="/admin"
                                label="Administración"
                                icon="admin_panel_settings"
                            ></app-nav-item>
                        }

                        <app-nav-item
                            tourAnchorId="app-nav-notifications"
                            routerLink="/notifications"
                            label="Notificaciones"
                            icon="notifications"
                        ></app-nav-item>
                    </mat-nav-list>
                </mat-sidenav>
            }

            <mat-sidenav-content
                style="background: var(--mat-sys-color-surface)"
            >
                <router-outlet></router-outlet>
            </mat-sidenav-content>
        </mat-sidenav-container>
    </div>
</div>

@if (isLogin$ | async) {
    <tour-step-template>
        <ng-template let-step="step">
            <mat-card
                class="dc-tour-step"
                (click)="$event.stopPropagation()"
                [style.width]="step.stepDimensions?.width"
                [style.min-width]="step.stepDimensions?.minWidth"
                [style.max-width]="step.stepDimensions?.maxWidth"
            >
                <mat-card-header>
                    <div class="dc-tour-header">
                        <mat-card-title>{{ step.title }}</mat-card-title>
                        <button
                            mat-button
                            type="button"
                            class="dc-tour-skip"
                            (click)="appTour.skip()"
                            [attr.aria-label]="'tour.app.buttons.skip' | translate"
                        >
                            {{ 'tour.app.buttons.skip' | translate }}
                        </button>
                    </div>
                </mat-card-header>

                <mat-card-content class="mat-body" [innerHTML]="step.content"></mat-card-content>

                <mat-card-actions [class.no-progress]="!step.showProgress">
                    <button
                        mat-button
                        type="button"
                        class="prev"
                        [disabled]="!tourService.hasPrev(step)"
                        (click)="tourService.prev()"
                    >
                        <mat-icon class="chevron-icon">chevron_left</mat-icon>
                        {{ step.prevBtnTitle }}
                    </button>
                    @if (step.showProgress) {
                        <div class="progress">
                            {{ tourService.steps.indexOf(step) + 1 }} /
                            {{ tourService.steps.length }}
                        </div>
                    }
                    @if (tourService.hasNext(step) && !step.nextOnAnchorClick) {
                        <button mat-button type="button" class="next" (click)="tourService.next()">
                            {{ step.nextBtnTitle }}
                            <mat-icon class="chevron-icon" iconPositionEnd>chevron_right</mat-icon>
                        </button>
                    }
                    @if (!tourService.hasNext(step)) {
                        <button mat-button type="button" (click)="appTour.finish()">
                            {{ step.endBtnTitle }}
                        </button>
                    }
                </mat-card-actions>
            </mat-card>
        </ng-template>
    </tour-step-template>
}
